import React from 'react';
import CircleLoader from 'react-spinners/CircleLoader';

export default () => (
  <div className="loading-container">
    <div style={{ display: 'inline-block' }}>
      <CircleLoader size={50} color="#ff7761" style={{ display: 'inline-block' }} />
    </div>
  </div>
);
